<header class="toolbar">
  <div class="toolbar-inner flex items-center justify-between gap-4 max-w-[1280px] mx-auto h-[72px] px-10 md-max:px-4">

    <!-- Brand -->
    <a href="#" class="brand flex items-center gap-3 shrink-0" id="public-toolbar-home-link">
      <img
        src="assets/icons/svg/caminhao_logo.svg"
        alt=""
        aria-hidden="true"
        class="brand-logo"
      />
      <span class="brand-name">Plataforma<br/><strong>de Fretes</strong></span>
    </a>

    <!-- Nav -->
    <nav class="nav hidden md:flex items-center gap-1 flex-1 justify-center">
      <a href="https://www.senior.com.br/" target="_blank" id="public-toolbar-about-link">{{ 'toolbar.about' | translate }}</a>
      <a href="#" id="public-toolbar-shipper-link">{{ 'toolbar.shipper' | translate }}</a>
      <a href="#" id="public-toolbar-carrier-link">{{ 'toolbar.carrier' | translate }}</a>
    </nav>

    <!-- Actions -->
    <div class="actions hidden md:flex items-center gap-2 shrink-0">
      <button class="btn-primary btn-enter flex items-center gap-2" id="public-toolbar-login-button" (click)="goToLoginWithFocus()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        {{ 'toolbar.login' | translate }}
      </button>

      <!-- Language dropdown -->
      <div class="lang-wrapper">
        <button class="btn-lang" id="public-toolbar-language-dropdown-button" (click)="toggleLanguageDropdown($event)">
          {{ getCurrentLangOption().flag }} {{ getCurrentLangOption().label }}
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            [class.chevron-open]="languageDropdownOpen">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
        @if (languageDropdownOpen) {
          <div class="lang-dropdown">
            @for (lang of availableLangs; track lang.code) {
              <button
                [id]="'public-toolbar-language-option-' + lang.code"
                class="lang-option"
                [class.active]="currentLang() === lang.code"
                (click)="changeLanguage(lang.code)">
                {{ lang.flag }} {{ lang.label }}
              </button>
            }
          </div>
        }
      </div>

      <!-- Theme toggle -->
      <button class="btn-theme" id="public-toolbar-theme-button" (click)="toggleTheme()"
        [title]="isDark() ? ('toolbar.theme_light' | translate) : ('toolbar.theme_dark' | translate)">
        <!-- Sun (shown in dark mode) -->
        @if (isDark()) {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" id="public-toolbar-light-theme-icon">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
          </svg>
        }
        <!-- Moon (shown in light mode) -->
        @if (!isDark()) {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" id="public-toolbar-dark-theme-icon">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        }
      </button>
    </div>

    <!-- Burger -->
    <button id="public-toolbar-burger-button" class="burger flex md:hidden items-center" (click)="toggleMenu()">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="6"  x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Mobile menu -->
  @if (menuOpen) {
    <div id="public-toolbar-mobile-menu" class="mobile-menu flex flex-col open">
      <a href="#" id="public-toolbar-mobile-about-link">{{ 'toolbar.about' | translate }}</a>
      <a href="#" id="public-toolbar-mobile-shipper-link">{{ 'toolbar.shipper' | translate }}</a>
      <a href="#" id="public-toolbar-mobile-carrier-link">{{ 'toolbar.carrier' | translate }}</a>
      <div class="mobile-actions flex items-center gap-2 mt-2">
        <button class="btn-primary mobile-enter flex-1 flex items-center justify-center gap-2" id="public-toolbar-mobile-login-button" (click)="goToLoginWithFocus()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          {{ 'toolbar.login' | translate }}
        </button>

        <!-- Mobile language dropdown -->
        <div class="lang-wrapper">
          <label class="sr-only" for="public-toolbar-mobile-language-select">{{ 'language.label' | translate }}</label>
          <select
            id="public-toolbar-mobile-language-select"
            class="btn-lang btn-lang-select"
            [value]="currentLang()"
            (change)="onLanguageSelectChange($event)"
          >
            @for (lang of availableLangs; track lang.code) {
              <option [value]="lang.code">{{ lang.flag }} {{ lang.label }}</option>
            }
          </select>
        </div>

        <button id="public-toolbar-mobile-theme-button" class="btn-theme btn-theme--mobile" (click)="toggleTheme()">
          @if (isDark()) {
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="4"/>
              <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
            </svg>
          }
          @if (!isDark()) {
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          }
        </button>
      </div>
    </div>
  }
</header>
